import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Was kostet eine professionelle Webseite?',
      answer: 'Eine komplette Webseite mit bis zu 7 Seiten kostet einmalig 899€. Darin enthalten sind Responsive Design, SEO-Optimierung, Kontaktformular, SSL-Zertifikat, DSGVO-Absicherung inkl. Datenschutzerklärung & Cookie-Management sowie 2 kostenlose Änderungen nach Fertigstellung.'
    },
    {
      question: 'Wie lange dauert die Erstellung einer Webseite?',
      answer: 'Ihre Webseite ist in maximal 1 Woche fertig. Durch meinen effizienten Arbeitsprozess mit AI-Unterstützung kann ich schnell hochwertige Ergebnisse liefern, ohne Kompromisse bei der Qualität einzugehen.'
    },
    {
      question: 'Was kosten nachträgliche Änderungen?',
      answer: 'Die ersten 2 Änderungen nach Fertigstellung sind kostenlos. Danach kosten kleinere Änderungen pauschal 50€ und ein Redesign oder größere Änderungen pauschal 120€. So behalten Sie volle Kostenkontrolle.'
    },
    {
      question: 'Was ist alles im Preis enthalten?',
      answer: 'Im Komplettpaket für 899€ sind enthalten: Bis zu 7 Seiten, Responsive Design für alle Geräte, SEO-Optimierung, ein Kontaktformular, SSL-Zertifikat für sichere Verbindungen, DSGVO-Absicherung mit Datenschutzerklärung & Cookie-Management sowie 2 kostenlose Änderungen.'
    },
    {
      question: 'Was genau ist ein AI-Chatbot?',
      answer: 'Ein AI-Chatbot ist ein intelligenter Assistent auf Ihrer Webseite, der rund um die Uhr Kundenanfragen beantwortet, Termine bucht und Leads generiert – vollautomatisch. Er lernt aus Ihren Unternehmensdaten und antwortet wie ein echter Mitarbeiter.'
    },
    {
      question: 'Ist meine Webseite DSGVO-konform?',
      answer: 'Ja, absolut. Jede Webseite wird mit vollständiger DSGVO-Absicherung ausgeliefert. Das umfasst eine rechtskonforme Datenschutzerklärung, professionelles Cookie-Management und ein SSL-Zertifikat – alles im Preis inbegriffen.'
    }
  ];

  return (
    <section id="faq" className="py-20 sm:py-24 bg-brand-beige-light">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-caprasimo mb-4 sm:mb-6 text-brand-black px-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-lg sm:text-xl text-brand-grey px-4">
            Alles, was Sie über meine Leistungen wissen müssen
          </p>
        </motion.div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              viewport={{ once: true }}
              className={`bg-white rounded-xl overflow-hidden transition-all border-2 ${
                openIndex === index ? 'border-brand-green shadow-lg' : 'border-brand-beige'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 sm:px-8 py-5 sm:py-6 flex items-center justify-between text-left hover:bg-brand-beige-light/50 transition-colors cursor-pointer min-h-[44px]"
              >
                <span className={`text-base sm:text-lg font-semibold pr-4 sm:pr-8 transition-colors ${
                  openIndex === index ? 'text-brand-green' : 'text-brand-black'
                }`}>
                  {faq.question}
                </span>
                <div className={`w-11 h-11 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === index ? 'bg-brand-green rotate-180' : 'bg-brand-beige-light'
                }`}>
                  <i className={`ri-arrow-down-s-line text-xl ${
                    openIndex === index ? 'text-white' : 'text-brand-green'
                  }`}></i>
                </div>
              </button>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-4 sm:px-8 pb-5 sm:pb-6 text-brand-grey leading-relaxed text-sm sm:text-base">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}